/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	EmailRecipientDTO,
	EmailRecipientDTOFromJSON,
	EmailRecipientDTOFromJSONTyped,
	EmailRecipientDTOToJSON,
} from "./EmailRecipientDTO";

/**
 *
 * @export
 * @interface EmailRecipientDTOPagedResponse
 */
export interface EmailRecipientDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof EmailRecipientDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EmailRecipientDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof EmailRecipientDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<EmailRecipientDTO>}
	 * @memberof EmailRecipientDTOPagedResponse
	 */
	data?: Array<EmailRecipientDTO> | null;
}

export function EmailRecipientDTOPagedResponseFromJSON(
	json: any
): EmailRecipientDTOPagedResponse {
	return EmailRecipientDTOPagedResponseFromJSONTyped(json, false);
}

export function EmailRecipientDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): EmailRecipientDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(EmailRecipientDTOFromJSON),
	};
}

export function EmailRecipientDTOPagedResponseToJSON(
	value?: EmailRecipientDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(EmailRecipientDTOToJSON),
	};
}
